var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form_url != null)?_c('div',{staticClass:"centralize",attrs:{"id":"form"}},[_c('iframe',{attrs:{"height":"680px","width":"420px","src":_vm.form_url,"title":"Formulario"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025bf9a7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewFormBuilder/NewFormBuilder.vue
// module id = 891
// module chunks = 1